export default __webpack_public_path__ + "2f92707a5c1d62d832a1ef996829117a.png";